import { render, staticRenderFns } from "./Historial.vue?vue&type=template&id=3fdfc2a9&lang=pug"
import script from "./Historial.vue?vue&type=script&lang=js"
export * from "./Historial.vue?vue&type=script&lang=js"
import style0 from "./Historial.vue?vue&type=style&index=0&id=3fdfc2a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports